import { Navigate, Route, Routes } from 'react-router-dom';
import Loading from '../components/Loading';
import { SidebarLayout } from '../layouts/SidebarLayout';
import Messages from '../pages/Messages';
import { PatientListProvider } from '../providers/patient/PatientsListProvider';
import { useUser } from '../providers/UserProvider';

export const MessagesRoutes = () => {
    const { isLoading, isAuthenticated } = useUser();

    if (isLoading) {
        return <Loading />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return (
        <Routes>
            <Route
                path="/"
                element={
                    <SidebarLayout>
                        <PatientListProvider>
                            <Messages />
                        </PatientListProvider>
                    </SidebarLayout>
                }
            />
        </Routes>
    );
};
